import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableColumn from "./types/order-optimizer-cargo-details-hidden-details-center-tables-table-column";

const getColumns =
  (): OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableColumn[] => {
    const tableColumns: OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "orders",
          colSpan: 10,
        },
      ];

    return tableColumns;
  };

const orderOptimizerCargoDetailsHiddenDetailsCenterTablesTableHelper = {
  getColumns,
};

export default orderOptimizerCargoDetailsHiddenDetailsCenterTablesTableHelper;
